// @ts-nocheck

import { timeline, easing } from 'popmotion';
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

import { ReactComponent as ChevronDown } from '../../assets/svg/chevron-down.svg';
import { ReactComponent as ChevronUp } from '../../assets/svg/chevron-up.svg';
import { usePrevious } from '../../hooks';

const Wrapper = styled.div`
  position: relative;
  margin: 0 0 0.2em 0;
`;

const IncreaseVariation = styled.div`
  position: absolute;
  display: block;
  left: 50%;
  top: 50%;
  margin-left: -0.5em;
  margin-top: -1.3em;
  width: 1em;
  height: 1em;
  z-index: 0;
  opacity: 0;
`;

const DecreaseVariation = styled(IncreaseVariation)`
  margin-top: 0.15em;
`;

const ChevronUpIcon = styled(ChevronUp)`
  width: 1em;
  height: 1em;
  display: block;
  color: ${({ theme }) => theme.common.colors.positive};
`;

const ChevronDownIcon = styled(ChevronDown)`
  width: 1em;
  height: 1em;
  display: block;
  color: ${({ theme }) => theme.common.colors.negative};
`;

const TweenUp = [
  { track: 'arrow', from: [0, 0], to: [-40, 1], duration: 500, ease: easing.easeInOut },
  { track: 'arrow', from: [-40, 1], to: [-80, 0], duration: 500, ease: easing.easeInOut },
];
const TweenDown = [
  { track: 'arrow', from: [0, 0], to: [40, 1], duration: 500, ease: easing.easeInOut },
  { track: 'arrow', from: [40, 1], to: [80, 0], duration: 500, ease: easing.easeInOut },
];

const CashoutButtonVariation = ({ children, disabled, value }) => {
  const animRef = useRef(null);
  const arrowUpNodeRef = useRef(null);
  const arrowDownNodeRef = useRef(null);
  const previousValue = usePrevious(value);

  useEffect(() => {
    if (!disabled && previousValue && value !== previousValue) {
      stopAnimation();
      const isAnimationValueGreater = value > previousValue;
      const onTweenAnimation = isAnimationValueGreater ? TweenUp : TweenDown;
      const onTweenAnimationUpdate = isAnimationValueGreater ? onTweenUpUpdate : onTweenDownUpdate;
      animRef.current = timeline(onTweenAnimation, { loop: 4 }).start(onTweenAnimationUpdate);
    }
  }, [disabled, value, previousValue]);

  useEffect(() => {
    return () => {
      stopAnimation();
    };
  }, []);

  const onTweenUpUpdate = (v) => {
    if (arrowUpNodeRef?.current) {
      arrowUpNodeRef.current.style.transform = `translateY(${v.arrow[0]}%)`;
      arrowUpNodeRef.current.style.opacity = v.arrow[1];
    }
  };

  const onTweenDownUpdate = (v) => {
    if (arrowDownNodeRef?.current) {
      arrowDownNodeRef.current.style.transform = `translateY(${v.arrow[0]}%)`;
      arrowDownNodeRef.current.style.opacity = v.arrow[1];
    }
  };

  const stopAnimation = () => {
    if (animRef?.current) {
      animRef.current.seek(1);
      animRef.current.stop();
      animRef.current = null;
    }
  };

  return (
    <Wrapper>
      {children}
      <IncreaseVariation ref={arrowUpNodeRef}>
        <ChevronUpIcon />
      </IncreaseVariation>
      <DecreaseVariation ref={arrowDownNodeRef}>
        <ChevronDownIcon />
      </DecreaseVariation>
    </Wrapper>
  );
};

export default CashoutButtonVariation;
